/**
 * orga-app-api - vorlagen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ChecklisteModelRequest { 
    abarbeitung_rollen_ids?: Array<string>;
    freigabe_rollen_ids?: Array<string>;
    lese_rollen_ids?: Array<string>;
    reihenfolge?: number;
    titel: string;
    checkliste_id: string;
    funktionsbereich_id: string;
}

